import { createPortal } from 'react-dom'

import { usePopoverManagerContext } from '../providers/PopoverManagerProvider'

export const Popover = () => {
    const { content } = usePopoverManagerContext()

    if (content === null) {
        return null
    }

    return createPortal(
        <div className="absolute inset-0 z-40 h-screen w-screen bg-white/90">{content}</div>,
        document.body
    )
}
